import { render, staticRenderFns } from "./DataConfigsTiles.vue?vue&type=template&id=0e40b9fd&"
import script from "./DataConfigsTiles.vue?vue&type=script&lang=js&"
export * from "./DataConfigsTiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports